import { trackAction as trackActionOM } from 'helpers/trackingOM';
import { urlHandler, getSearchParams } from 'helpers/urlHandler';

/**
 *
 * isDeeplinking = searchReferral (google-organic | spotlight,spotlight#open)
 */
const deeplinkTracking = () => {
    const fullUrl = urlHandler().fullUrl;
    const isDeeplinking = ['searchReferral'];

    const trackAction = () => {
        const cdata = {
            deepLinkSource: getSearchParams()?.source ?? 'undefined',
            deepLinkPath: fullUrl ?? 'undefined',
            pageName: 'deep-link',
        };
        // Be sure that we are under a search feed before send the tracking
        if (isDeeplinking.find((deeplink) => getSearchParams()?.[deeplink]) !== undefined) {
            trackActionOM('trackDeepLink', cdata);
        }
    };

    return {
        trackAction,
    };
};

export default deeplinkTracking;
